module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tweet-card-container"
  }, [_c('div', {
    staticClass: "tweet-card"
  }, [_c('div', [_c('div', {
    staticClass: "tweet-card-header"
  }, [_c('div', [_c('h5', [_vm._v(_vm._s(_vm.$t('str.ComposeNewTweet')))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-times",
    on: {
      "click": _vm.close
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tweet-card-slide"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.slideUrl
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tweet-card-comment"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "name": "user-text",
      "maxlength": "280",
      "placeholder": _vm.$t('str.WhatIsHappening')
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tweet-card-footer"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.message.length) + " / 280")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.tweetSlide
    }
  }, [_vm._v(_vm._s(_vm.$t('str.TWEET')))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18d7db3c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TweetSlideUI.vue
// module id = 461
// module chunks = 0